(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-policy-consent"] && !Shopify.designMode) return;
  try {
    document.addEventListener('invalid',event=>{if(event.target.matches('.cart-policy-consent input[type=checkbox]'))event.target.setCustomValidity(event.target.closest('fieldset').dataset.requiredMessage);},true);
document.addEventListener('change',event=>{if(event.target.matches('.cart-policy-consent input[type=checkbox]'))event.target.setCustomValidity('');});
  } catch(e) { console.error(e); }
})();

})();
